import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { containerVariants, itemVariants } from '../../utils/animations';
import debtorApi, { Debtor } from '../../api/debtorApi';

import DebtorListHeader from '../../components/debtor/list/DebtorListHeader';
import DebtorFilters from '../../components/debtor/list/DebtorFilters';
import DebtorTable from '../../components/debtor/list/DebtorTable';
import DebtorDeleteDialog from '../../components/debtor/list/DebtorDeleteDialog';

export default function DebtorList() {
  const [debtors, setDebtors] = useState<Debtor[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterDocStatus, setFilterDocStatus] = useState('all');
  const [deleteId, setDeleteId] = useState<number | null>(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const data = await debtorApi.getAll();
      setDebtors(data || []);
    } catch (error) {
      // Error loading debtors
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await debtorApi.delete(deleteId);
      setDebtors(debtors.filter(d => d.id !== deleteId));
      setDeleteId(null);
    } catch (error) {
      // Error deleting debtor
    }
  };

  const filteredDebtors = debtors.filter(debtor => {
    const matchSearch =
      debtor.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      debtor.cif?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      debtor.id_number?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchStatus = filterStatus === 'all' || debtor.status === filterStatus;
    const matchDocStatus = filterDocStatus === 'all' || debtor.document_status === filterDocStatus;
    return matchSearch && matchStatus && matchDocStatus;
  });

  return (
    <motion.div
      className="space-y-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div variants={itemVariants}>
        <DebtorListHeader />
      </motion.div>

      <motion.div variants={itemVariants}>
        <DebtorFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          filterDocStatus={filterDocStatus}
          setFilterDocStatus={setFilterDocStatus}
        />
      </motion.div>

      <motion.div variants={itemVariants}>
        <DebtorTable debtors={filteredDebtors} loading={loading} onDelete={setDeleteId} />
      </motion.div>

      <DebtorDeleteDialog
        open={!!deleteId}
        onClose={() => setDeleteId(null)}
        onConfirm={handleDelete}
      />
    </motion.div>
  );
}
